import {
  SET_CHAT_LOADING,
  SET_CHAT_SUCCESS,
  SET_CHAT_ERROR,
  SET_CONVO_LOADING,
  SET_CONVO_SUCCESS,
  SET_CONVO_ERROR,
  SET_RECENT_CONVO_LOADING,
  SET_RECENT_CONVO_SUCCESS,
  SET_RECENT_CONVO_ERROR
} from '../../Constants/action-types';

const initialState = {
  chatLoading: false,
  chatSuccess: false,
  chatError: false,
  completion: '',
  conversationId: null,

  convoLoading: false,
  convoSuccess: false,
  convoError: false,
  conversation: null,

  recentConvoLoading: false,
  recentConvoSuccess: false,
  recentConvoError: false,
  recentConvoErrorMessage: '',
  recentConversationId: null
};

export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CHAT_LOADING:
      return {
        ...state,
        chatLoading: true,
        chatSuccess: false,
        chatError: false,
        completion: ''
      };
    case SET_CHAT_SUCCESS:
      return {
        ...state,
        chatLoading: false,
        chatSuccess: true,
        chatError: false,
        completion: action.payload.completion,
        conversationId: action.payload.conversation_id
      };
    case SET_CHAT_ERROR:
      return {
        ...state,
        chatLoading: false,
        chatSuccess: false,
        chatError: true
      };

    case SET_CONVO_LOADING:
      return {
        ...state,
        convoLoading: true,
        convoSuccess: false,
        convoError: false
      };
    case SET_CONVO_SUCCESS:
      return {
        ...state,
        convoLoading: false,
        convoSuccess: true,
        convoError: false,
        conversation: action.payload
      };
    case SET_CONVO_ERROR:
      return {
        ...state,
        convoLoading: false,
        convoSuccess: false,
        convoError: true
      };

    case SET_RECENT_CONVO_LOADING:
      return {
        ...state,
        recentConvoLoading: true,
        recentConvoSuccess: false,
        recentConvoError: false,
        recentConvoErrorMessage: ''
      };
    case SET_RECENT_CONVO_SUCCESS:
      return {
        ...state,
        recentConvoLoading: false,
        recentConvoSuccess: true,
        recentConvoError: false,
        recentConversationId: action.payload.conversation_id,
        conversationId: action.payload.conversation_id,
        recentConvoErrorMessage: ''
      };
    case SET_RECENT_CONVO_ERROR:
      return {
        ...state,
        recentConvoLoading: false,
        recentConvoSuccess: false,
        recentConvoError: true,
        recentConvoErrorMessage: action.error,
        conversation: action.newsroomExampleChat
      };

    default:
      return state;
  }
}
